/**
 * Theme-aware colors for the Three.js dither effects. The effects keep
 * module-level THREE.Color constants for hot loops, so they pull a palette
 * from here at mount and again whenever the theme toggles (event below).
 */
export const THEME_CHANGE_EVENT = 'kirana:themechange'

export function isDarkTheme() {
  return typeof document !== 'undefined' && document.documentElement.dataset.theme === 'dark'
}

export function ditherPalette() {
  return isDarkTheme()
    ? { accent: '#8b81ff', fade: '#191627', mapBase: '#2c2947', delivery: '#6a63cc' }
    : { accent: '#5145ff', fade: '#eef0fc', mapBase: '#dcdae9', delivery: '#8d87ff' }
}
